import { configPromise } from '../../config';
import Api from '../api';
import { commandApi } from '../commandApi';

const GET_REPORTS_STATUS = '/api/2bap/reports';
const GENERATE_FLIGHTPATH_REPORT = '/api/2bap/reports/coverage-flightpath/pdf';
const GENERATE_INDIVIDUAL_COVERAGE_REPORT = '/api/2bap/reports/individual-coverage/pdf';
const GENERATE_PLANNING_ASSISTANT_REPORT = '/api/2bap/reports/planning-assistant/pdf';
const GENERATE_LEARNER_OBSERVATION_REPORT_COMMAND = 'generate-learner-observation-report';
const GENERATE_CUSTOM_REPORT_COMMAND = 'reports:generate-report';
const DELETE_REPORT = `${GET_REPORTS_STATUS}/{0}`;
const REGENERATE_REPORT = '/api/2bap/reports/{0}/generate';
const GET_CATEGORIES = '/api/2bap/reports/report-categories';
const GET_REPORT_TYPES = '/api/2bap/reports/report-types';
const GET_REPORT_CONFIG= '2bap:get-report-configuration';
const ADD_TO_FAVOURITES = '/api/2bap/reports/report-types/favorites';

const GENERATE_GROUP_ASSESSMENT_REPORT_COMMAND = 'generate-group-assessment-report';
const GET_REPORT_TEMPLATES_COMMAND = 'reports:get-report-templates-lookup';
const SET_DEFAULT_REPORT_TEMPLATE_COMMAND = 'reports:set-default-report-template';
const GET_DEFAULT_REPORT_FILTER_COMMAND = '2bap:get-report-filter-defaults';
const GET_OBSERVATIONS_COUNT_COMMAND = 'reports:get-learner-observation-report-observations-count';

// TODO: review and move methods that are not related to report logic to learners/classes api
class BAPReportsApi {

  async getReportCategories() {
    const config = await configPromise;
    return Api.get(config.apiPath(GET_CATEGORIES));
  }

  async getReportList(categoryId) {
    const config = await configPromise;
    return Api.get(config.apiPath(GET_REPORT_TYPES), { categoryId, hasLearnersLimit: true });
  }

  async getReportConfig(reportType) {
    return commandApi.send(GET_REPORT_CONFIG, { reportType});
  }

  async getReportTemplates(reportType) {
    return commandApi.send(GET_REPORT_TEMPLATES_COMMAND, { reportType });
  }

  async setDefaultReportTemplate(id, reportType, isParentDefault) {
    return commandApi.send(SET_DEFAULT_REPORT_TEMPLATE_COMMAND, { id, reportType, isParentDefault });
  }

  async generateFlightPathReport(model) {
    const config = await configPromise;
    return Api.post(config.apiPath(GENERATE_FLIGHTPATH_REPORT), model);
  }

  async generateIndividualCoverageReport(model) {
    const config = await configPromise;
    return Api.post(config.apiPath(GENERATE_INDIVIDUAL_COVERAGE_REPORT), model);
  }

  async generatePlanningAssistantReport(model) {
    const config = await configPromise;
    return Api.post(config.apiPath(GENERATE_PLANNING_ASSISTANT_REPORT), model);
  }

  async generateLearnerObservationReport(filter) {
    return commandApi.send(GENERATE_LEARNER_OBSERVATION_REPORT_COMMAND, filter);
  }

  async generateCustomReport(reportType, filter) {
    return commandApi.send(GENERATE_CUSTOM_REPORT_COMMAND, { reportType, filter });
  }

  /**
   * @param {AssessmentReportGenerationModel} model
   * @return {Promise<*>}
   */
  async generateGroupAssessmentReport(model) {
    return commandApi.send(GENERATE_GROUP_ASSESSMENT_REPORT_COMMAND, model);
  }

  async getReportsStatus(paging) {
    const config = await configPromise;
    return Api.get(config.apiPath(GET_REPORTS_STATUS), paging);
  }

  async deleteReport(id) {
    const config = await configPromise;
    return Api.delete(config.apiPath(DELETE_REPORT, [id]));
  }

  async regenerateReport(id) {
    const config = await configPromise;
    return Api.post(config.apiPath(REGENERATE_REPORT, [id]));
  }

  async addToFavourites(reports) {
    const config = await configPromise;
    return Api.put(config.apiPath(ADD_TO_FAVOURITES), reports);
  }

  /**
   * @param {string} reportType
   * @param {number} frameworkRootId
   * @return {Promise<ReportGenerationModel>}
   */
  getDefaultReportFilter(reportType, frameworkRootId) {
    return commandApi.send(GET_DEFAULT_REPORT_FILTER_COMMAND, { reportType, frameworkRootId });
  }

  async getObservationsCountMessage(model) {
    return commandApi.send(GET_OBSERVATIONS_COUNT_COMMAND, model);
  }

}

export default new BAPReportsApi();
